/** ****************** BEWARE ************************
Additional experiments affect caching
- Only provide experiments actively used by the API's
- Expiry must be within 90 days
- Your experiment will not be passed after the expiry
- Extend expiry via additional PR's only if necessary
- Expiry date should be in format new Date('YYYY-MM-DD')
- Use with caution; logGlobally determines if the experiment assignment should be tracked on every page load
*****************************************************/
export type Experiment = { key: string; expiry?: Date; logGlobally?: boolean }

export const graphQlExperimentsWhitelist: Array<Experiment> = [
  {
    key: 'basket-personalised-promotion-model',
    expiry: new Date('2026-02-24'),
    logGlobally: true,
  },
  {
    key: 'price-trial',
    logGlobally: true,
  },
  {
    key: 'search-use-age-selection-ux-v2',
    logGlobally: true,
  },
  {
    key: 'purchase-filter-out-first-class-delivery-methods',
    expiry: new Date('2026-08-01'),
    logGlobally: false,
  },
  {
    key: 'attach-gift-xsell-milestone-recommendations',
    expiry: new Date('2026-12-01'),
    logGlobally: true,
  },
  {
    key: 'attach-design-inference-recommendations',
    expiry: new Date('2026-12-27'),
    logGlobally: false,
  },
  {
    key: 'purchase-web---delivery-scheduler-heading-change',
    expiry: new Date('2026-11-30'),
    logGlobally: false,
  },
  {
    key: 'fulfilment-rm-2nd-class-enabled',
    expiry: new Date('2026-11-14'),
    logGlobally: false,
  },
  {
    key: 'search-use-recipient-group-filtering',
    logGlobally: true,
  },
  {
    key: 'search-use-promotional-filters',
    logGlobally: true,
  },
  {
    key: 'search-use-typo-tolerance',
    logGlobally: true,
  },
]
